<div [ngClass]="{'spAssessmentsIframe': true}">
  <iframe [ngClass]="{'spAssessmentsIframe': true}" [src]="spAccessUrl | safe"></iframe>
</div>
